import { combineReducers } from 'redux';

import {
  garageCleanupRequested,
  removalFromGarageRequested,
  replaceVehicleValue,
  vehicleDiscardingRequested,
} from 'Core/actions/fitmentSearch/index.js';
import { createReducersFromShorthands } from 'Core/reducers/common.ts';
import getVehicleFromUri from 'Modules/converter/getVehicleFromUri.js';
import { loadSelectedVehicle } from 'Utils/userStorage.js';
import { updateVehicleSelection } from '../common.js';

const vehicleFromUriSelection = getVehicleFromUri().selection;

const initStates = {
  selection: vehicleFromUriSelection.length ? vehicleFromUriSelection : loadSelectedVehicle().selection,
};

export default combineReducers(
  createReducersFromShorthands(
    {
      selection: {
        [garageCleanupRequested]: () => [],
        [vehicleDiscardingRequested]: () => [],
        [removalFromGarageRequested]: (state, { meta }) => (meta.wasSelected ? [] : state),
        [replaceVehicleValue]: (state, { payload, meta: { fitmentFields } }) =>
          updateVehicleSelection(state, payload, fitmentFields),
      },
    },
    initStates,
  ),
);
